var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uy8cbaksca)",
    stroke: "#344054",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.605 12.273a1.25 1.25 0 0 0 .25 1.379l.046.045a1.515 1.515 0 0 1-1.072 2.589 1.514 1.514 0 0 1-1.072-.445l-.046-.045a1.25 1.25 0 0 0-1.378-.25 1.25 1.25 0 0 0-.758 1.144v.128a1.515 1.515 0 1 1-3.03 0v-.068a1.25 1.25 0 0 0-.818-1.144 1.25 1.25 0 0 0-1.38.25l-.045.046a1.514 1.514 0 0 1-2.472-.492 1.515 1.515 0 0 1 .328-1.652l.046-.046a1.25 1.25 0 0 0 .25-1.378 1.25 1.25 0 0 0-1.144-.758h-.129a1.515 1.515 0 1 1 0-3.03h.068a1.25 1.25 0 0 0 1.144-.818 1.25 1.25 0 0 0-.25-1.38l-.045-.045A1.515 1.515 0 1 1 6.242 4.16l.045.046a1.25 1.25 0 0 0 1.379.25h.06a1.25 1.25 0 0 0 .758-1.144v-.129a1.515 1.515 0 0 1 3.03 0v.068a1.25 1.25 0 0 0 .758 1.144 1.25 1.25 0 0 0 1.379-.25l.045-.045a1.515 1.515 0 0 1 2.589 1.072 1.514 1.514 0 0 1-.445 1.072l-.045.045a1.25 1.25 0 0 0-.25 1.379v.06a1.25 1.25 0 0 0 1.144.758h.128a1.515 1.515 0 1 1 0 3.03h-.068a1.25 1.25 0 0 0-1.144.758z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uy8cbaksca"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings01);
export default __webpack_public_path__ + "static/media/settings-01.c76b50c3724497a88471dc67444226db.svg";
export { ForwardRef as ReactComponent };